export default {
  title: 'Selección de expediente de financiación',
  search: 'Buscar acuerdos',
  expedient: 'Expediente',
  description: 'Acuerdo',
  amount: 'Anticipo disponible'
}
